// import React, { useLayoutEffect, useRef } from 'react';
// import * as am5 from "@amcharts/amcharts5";
// import * as am5percent from "@amcharts/amcharts5/percent";
// import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

// am5.addLicense("AM5C258896422");

// const PieChart = ({
//     chartData,
//     chartId = "chartdiv",
//     chartClass = ""
// }) => {
//     const chartRef = useRef(null);
//     const rootRef = useRef(null);

//     useLayoutEffect(() => {
//         // Create root element
//         const root = am5.Root.new(chartId);
//         rootRef.current = root;

//         // Set themes
//         root.setThemes([
//             am5themes_Animated.new(root)
//         ]);

//         // Create chart
//         const chart = root.container.children.push(am5percent.PieChart.new(root, {
//             layout: root.verticalLayout,
//             tooltip: am5.Tooltip.new(root, {})
//         }));

//         // Create series
//         const series = chart.series.push(am5percent.PieSeries.new(root, {
//             valueField: "value",
//             categoryField: "category",
//             alignLabels: false
//         }));
// series.set("colors", am5.ColorSet.new(root, {
//     colors: [
//         am5.color(0x4CC3FD), // Non promotion
//         am5.color(0x8298FB), // No promo
//         am5.color(0xFFB866), // Promo
//     ],
//     passOptions: {
//         lightness: 0
//     }
// }));
//         // Disable labels and ticks
//         series.labels.template.setAll({
//             forceHidden: true
//         });
//         series.labels.template.set("visible", false);
//         series.ticks.template.set("visible", false);
//         series.slices.template.set("toggleKey", "none");

//         // Set data
//         series.data.setAll(chartData);

//         // Custom tooltip configuration
//         const tooltip = series.set(
//             "tooltip",
//             am5.Tooltip.new(root, {
//                 getFillFromSprite: false,
//                 getStrokeFromSprite: false,
//                 autoTextColor: false,
//                 pointerOrientation: "horizontal",
//                 position: "pointer",
//             })
//         );

//         // Tooltip background styling
//         tooltip.get("background").setAll({
//             fill: am5.color(0x213345),
//             oversizedBehavior: "truncate",
//             cornerRadius: 5,
//         });

//         // Modify tooltip text
//         series.slices.template.set("tooltipText", "[bold]{category}[/]\n{valuePercentTotal.formatNumber('0.00')}%");

//         // Tooltip label styling
//         tooltip.label.setAll({
//             fill: am5.color(0xffffff),
//              fontWeight: "bold",
//              fontSize: 12,
//                 maxWidth: 300,
//                 oversizedBehavior: "wrap",
//                 fontFamily: "Ubuntu",
//         });

//         // Add legend
//         const legend = chart.children.push(
//             am5.Legend.new(root, {
//                 position: "relative",
//                 centerX: am5.percent(50),
//                 x: am5.percent(50),
//                 height: chartData.length >= 6 ? am5.percent(30) : null,
//                 marginTop: 15,
//                 layout: am5.GridLayout.new(root, {
//                     maxColumns: 10,
//                     fixedWidthGrid: true,
//                 }),
//                 verticalScrollbar: am5.Scrollbar.new(root, {
//                     orientation: "vertical",
//                 }),
//             })
//         );

//         // Legend marker styling
//         legend.markers.template.setAll({
//             width: 13,
//             height: 13,
//         });

//         legend.markerRectangles.template.setAll({
//             cornerRadiusTL: 10,
//             cornerRadiusTR: 10,
//             cornerRadiusBL: 10,
//             cornerRadiusBR: 10,
//         });

//         // Legend label styling
//         legend.labels.template.setAll({
//             fontSize: 12,
//             fontWeight: "400",
//             fill: "#213345",
//             oversizedBehavior: "wrap",
//         });

//         // Hide legend value labels
//         legend.valueLabels.template.set("forceHidden", true);
//         legend.data.setAll(series.dataItems);

//         // Play initial series animation
//         series.appear(1000, 100);

//         // Store reference to chart
//         chartRef.current = chart;

//         // Cleanup
//         return () => {
//             root.dispose();
//         };
//     }, [chartData, chartId]);

//     return (
//         <div
//             id={chartId}
//             className={`amchart-pie-container ${chartClass}`}
//         />
//     );
// };

// export default PieChart;



import React, { useLayoutEffect, useRef } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

am5.addLicense("AM5C258896422");

const PieChart = ({
    chartData,
    chartId = "chartdiv",
    chartClass = ""
}) => {
    const chartRef = useRef(null);
    const rootRef = useRef(null);

    useLayoutEffect(() => {
        // Create root element
        const root = am5.Root.new(chartId);
        rootRef.current = root;

        // Set themes
        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        // Create chart
        const chart = root.container.children.push(am5percent.PieChart.new(root, {
            layout: root.verticalLayout,
            tooltip: am5.Tooltip.new(root, {})
        }));

        // Create series
        const series = chart.series.push(am5percent.PieSeries.new(root, {
            valueField: "value",
            categoryField: "category",
            alignLabels: false
        }));

        series.set("colors", am5.ColorSet.new(root, {
            colors: [
                am5.color(0x4CC3FD),
                am5.color(0x8298FB),
                am5.color(0xFFB866),
            ],
            passOptions: {
                lightness: 0
            }
        }));

        // Disable labels and ticks
        series.labels.template.setAll({
            forceHidden: true
        });
        series.labels.template.set("visible", false);
        series.ticks.template.set("visible", false);
        series.slices.template.set("toggleKey", "none");

        // Set data
        series.data.setAll(chartData);

        // Custom tooltip configuration
        const styledTooltip = am5.Tooltip.new(root, {
            getFillFromSprite: false,
            getStrokeFromSprite: false,
            autoTextColor: false,
            pointerOrientation: "horizontal",
            position: "pointer",
        });

        // Tooltip background styling
        styledTooltip.get("background").setAll({
            fill: am5.color(0x213345),
            oversizedBehavior: "truncate",
            cornerRadius: 5,
        });

        // Tooltip label styling
        styledTooltip.label.setAll({
            fill: am5.color(0xffffff),
            fontWeight: "bold",
            fontSize: 12,
            maxWidth: 300,
            oversizedBehavior: "wrap",
            fontFamily: "Ubuntu",
        });

        // Attach the styled tooltip to series slices
        series.slices.template.set("tooltip", styledTooltip);

        // Tooltip content: colored dot + category + percent value in bold
        series.slices.template.adapters.add("tooltipText", (text, target) => {
            const ctx = target.dataItem?.dataContext;
            if (!ctx) return "";
            // Get this slice's color
            const color = target.get("fill") ? target.get("fill").toCSSHex() : "#4CC3FD";
            // Compose tooltip
            let output =
                `[font-size:12px][#${color.replace("#", "")}]●[/] [bold]${ctx.category}[/]\n` +
                `${ctx.valuePercentTotal !== undefined ? Number(ctx.valuePercentTotal).toFixed(2) : "0.00"}%`;
            return output;
        });

        // Add legend
        const legend = chart.children.push(
            am5.Legend.new(root, {
                position: "relative",
                centerX: am5.percent(50),
                x: am5.percent(50),
                height: chartData.length >= 6 ? am5.percent(30) : null,
                marginTop: 15,
                layout: am5.GridLayout.new(root, {
                    maxColumns: 10,
                    fixedWidthGrid: true,
                }),
                verticalScrollbar: am5.Scrollbar.new(root, {
                    orientation: "vertical",
                }),
            })
        );

        // Legend marker styling
        legend.markers.template.setAll({
            width: 12,
            height: 12,
        });

        legend.markerRectangles.template.setAll({
            cornerRadiusTL: 10,
            cornerRadiusTR: 10,
            cornerRadiusBL: 10,
            cornerRadiusBR: 10,
        });

        // Legend label styling
        legend.labels.template.setAll({
            // fontSize: 14,
            // fontWeight: "300",
            // fill: "#213345",
            // oversizedBehavior: "wrap",
                fontFamily: "Ubuntu, sans-serif",
                               fontSize: 12,
                               fill: am5.color(0x213345),
                    marginLeft: 8,
                    marginRight: 0,
                    textAlign: "center",
                    centerY: am5.p50,
                    fontFamily: "Ubuntu"
        });

        // Hide legend value labels
        legend.valueLabels.template.set("forceHidden", true);
        legend.data.setAll(series.dataItems);

        // Play initial series animation
        series.appear(1000, 100);

        // Store reference to chart
        chartRef.current = chart;

        // Cleanup
        return () => {
            root.dispose();
        };
    }, [chartData, chartId]);

    return (
        <div
            id={chartId}
            className={`amchart-pie-container ${chartClass}`}
        />
    );
};

export default PieChart;